import { jsxs as T, jsx as o } from "react/jsx-runtime";
import I, { useRef as w, useCallback as y, useEffect as x } from "react";
import { deprecated as F } from "@material/chips/dist/mdc.chips.js";
import { withRipple as E } from "@rmwc/ripple";
import { Icon as B } from "@rmwc/icon";
import { useId as L, useFoundation as j, emptyClientRect as A, createComponent as N, useClassNames as R, Tag as P } from "@rmwc/base";
const { MDCChipFoundation: D, MDCChipAdapter: J, EventSource: Q } = F, M = (r) => {
  const t = L("chip", r), a = w(), h = (n) => {
    a.current = n;
  }, d = j({
    props: r,
    elements: {
      rootEl: !0,
      trailingIconEl: !0,
      checkmarkEl: !0,
      trailingActionEl: !0
    },
    foundation: ({ rootEl: n, checkmarkEl: _, emit: g, getProps: v, trailingActionEl: C }) => new D({
      addClass: (e) => {
        n.addClass(e);
      },
      removeClass: (e) => n.removeClass(e),
      hasClass: (e) => n.hasClass(e),
      addClassToLeadingIcon: (e) => {
      },
      removeClassFromLeadingIcon: (e) => {
      },
      eventTargetHasClass: (e, c) => n.hasClass(c) || e.classList.contains(c),
      notifyInteraction: () => g(
        "onInteraction",
        { chipId: t },
        !0
        /* shouldBubble */
      ),
      notifySelection: (e) => g(
        "onSelect",
        { chipId: t, selected: e },
        !0
        /* shouldBubble */
      ),
      notifyTrailingIconInteraction: () => g(
        "onTrailingIconInteraction",
        { chipId: t },
        !0
        /* shouldBubble */
      ),
      notifyRemoval: () => g(
        "onRemove",
        { chipId: t, root: n.ref },
        !0
        /* shouldBubble */
      ),
      notifyNavigation: (e, c) => {
      },
      getComputedStyleValue: (e) => n.ref ? window.getComputedStyle(n.ref).getPropertyValue(e) : "",
      setStyleProperty: (e, c) => {
        n.setStyle(e, c);
      },
      getAttribute: (e) => {
        var c;
        return (c = n.ref) == null ? void 0 : c.getAttribute(e);
      },
      hasLeadingIcon: () => !!r.icon,
      getRootBoundingClientRect: () => {
        var e;
        return ((e = n.ref) == null ? void 0 : e.getBoundingClientRect()) || A;
      },
      getCheckmarkBoundingClientRect: () => {
        var e;
        return ((e = _.ref) == null ? void 0 : e.getBoundingClientRect()) || A;
      },
      setPrimaryActionAttr: (e, c) => {
      },
      focusPrimaryAction: () => {
      },
      setTrailingActionAttr: (e, c) => {
        const S = e === "tabindex" ? "tabIndex" : e;
        return C.setProp(S, c);
      },
      focusTrailingAction: () => {
        var e;
        return (e = C.ref) == null ? void 0 : e.focus();
      },
      removeTrailingActionFocus: () => {
        var e;
        return (e = a.current) == null ? void 0 : e.getFoundation().removeFocus();
      },
      isTrailingActionNavigable: () => {
        var e;
        return (e = a.current) == null ? void 0 : e.getFoundation().isNavigable();
      },
      isRTL: () => n.ref ? window.getComputedStyle(n.ref).getPropertyValue("direction") === "rtl" : !1,
      notifyEditFinish: () => {
      },
      notifyEditStart: () => {
      }
    })
  }), { rootEl: l, trailingIconEl: u, foundation: i } = d, { onClick: s, onKeyDown: m } = r, p = y(
    (n) => (n.type === "click" && (s == null || s(n)), n.type === "keydown" && (m == null || m(n)), i.handleClick()),
    [i, s, m]
  ), k = y(
    (n) => {
      i.handleTransitionEnd(n);
    },
    [i]
  ), f = y(() => i.handleTrailingActionInteraction(), [i]);
  return x(() => {
    i.setShouldRemoveOnTrailingIconClick(
      r.trailingIconRemovesChip ?? !0
    );
  }, [i, r.trailingIconRemovesChip]), l.setProp("onClick", p, !0), l.setProp("onKeyDown", p, !0), l.setProp("onTransitionEnd", k, !0), u.setProp("onClick", f, !0), u.setProp("onKeyDown", f, !0), { setTrailingAction: h, ...d };
}, U = E()(
  N(function(t, a) {
    const {
      onInteraction: h,
      onTrailingIconInteraction: d,
      onRemove: l,
      onSelect: u,
      icon: i,
      trailingIcon: s,
      trailingIconRemovesChip: m,
      checkmark: p,
      label: k,
      children: f,
      selected: n,
      foundationRef: _,
      ...g
    } = t, { rootEl: v, checkmarkEl: C, trailingIconEl: e } = M(t), c = R(t, [
      "mdc-chip",
      {
        "mdc-chip--selected": n
      }
    ]);
    return /* @__PURE__ */ T(
      P,
      {
        role: "row",
        ...g,
        element: v,
        className: c,
        ref: a,
        children: [
          /* @__PURE__ */ o(V, {}),
          !!i && /* @__PURE__ */ o(b, { icon: i, leading: !0, hidden: n && p }),
          !!p && /* @__PURE__ */ o(
            H,
            {
              ref: C.reactRef
            }
          ),
          /* @__PURE__ */ o("span", { role: "gridcell", children: /* @__PURE__ */ o(
            "span",
            {
              role: "button",
              className: "mdc-chip__text__primary-action",
              tabIndex: 0,
              children: /* @__PURE__ */ T("span", { className: "mdc-chip__text", children: [
                k,
                f
              ] })
            }
          ) }),
          !!s && /* @__PURE__ */ o(
            b,
            {
              icon: s,
              trailing: !0,
              ...e.props({})
            }
          )
        ]
      }
    );
  })
), V = I.memo(function() {
  return /* @__PURE__ */ o("div", { className: "mdc-chip__ripple" });
}), H = I.memo(
  I.forwardRef(function(t, a) {
    return /* @__PURE__ */ o("div", { ref: a, className: "mdc-chip__checkmark", children: /* @__PURE__ */ o("svg", { className: "mdc-chip__checkmark-svg", viewBox: "-2 -3 30 30", children: /* @__PURE__ */ o(
      "path",
      {
        className: "mdc-chip__checkmark-path",
        fill: "none",
        stroke: "black",
        d: "M1.73,12.91 8.1,19.28 22.79,4.59"
      }
    ) }) });
  })
), b = I.memo(function(t) {
  const { leading: a, trailing: h, hidden: d, ...l } = t, u = R(t, [
    "mdc-chip__icon",
    {
      "mdc-chip__icon--leading": a,
      "mdc-chip__icon--leading-hidden": d,
      "mdc-chip__icon--trailing": h
    }
  ]), i = Object.keys(t).some(
    (m) => m.startsWith("on")
  ), s = t.trailing || i ? { role: "button", tabIndex: 0 } : {};
  return /* @__PURE__ */ o(B, { ...s, ...l, className: u });
}), X = N(
  function(t, a) {
    const { choice: h, filter: d, ...l } = t, u = R(t, [
      "mdc-chip-set",
      {
        "mdc-chip-set--choice": h,
        "mdc-chip-set--filter": d
      }
    ]);
    return /* @__PURE__ */ o(P, { ...l, ref: a, className: u });
  }
);
export {
  U as Chip,
  X as ChipSet
};
